module.exports = __webpack_public_path__ + "static/media/zolePlayed_10000_50000.bcc86923.png";